import { api, unwrap } from '../../shared/api/client';
import type { components } from '../../shared/api/schema.gen';

export type TCustomDomains = components['schemas']['CustomDomainsResDto'];
export type TCustomDomain = components['schemas']['CustomDomainResDto'];
export type TCustomDomainUsage = components['schemas']['CustomDomainUsageResDto'];

export const listCustomDomains = (): Promise<TCustomDomains> =>
  unwrap(api.GET('/v1/custom-domains'));

export const addCustomDomain = (hostname: string): Promise<TCustomDomain> =>
  unwrap(api.POST('/v1/custom-domains', { body: { hostname } }));

export const checkCustomDomain = (id: string): Promise<TCustomDomain> =>
  unwrap(api.POST('/v1/custom-domains/{id}/check', { params: { path: { id } } }));

export const customDomainUsage = (id: string): Promise<TCustomDomainUsage> =>
  unwrap(api.GET('/v1/custom-domains/{id}/usage', { params: { path: { id } } }));

export const removeCustomDomain = (id: string): Promise<void> =>
  unwrap(api.DELETE('/v1/custom-domains/{id}', { params: { path: { id } } }));
